import { Box, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";
import { getLocalDate, getLocalTime } from "../../../utils";
const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",

    marginTop: 15,
    marginBottom: 15,
    alignItems: "center",
  },
}));
const CustomDateField = ({ record, source }) => {
  const classes = useStyles();
  return (
    <Box className={classes.container}>
      <Typography>
        {getLocalDate(record[source])} {getLocalTime(record[source])}
      </Typography>
    </Box>
  );
};

export default CustomDateField;
